(function () {
  // Set data-sprice on the case-number option matching the current variant
  var vsel0 = document.querySelector('.product-variants-innerpanel .variant-selector');
  var variantId0 = vsel0 ? vsel0.value : '';
  document.querySelectorAll('#case-number option').forEach(function (current) {
    if (current.getAttribute('data-id') == variantId0) {
      setTimeout(function () {
        var sub = document.querySelector('.subscription-radio .price-label');
        current.setAttribute('data-sprice', sub ? sub.textContent : '');
      }, 1500);
    }
  });

  // Format discount labels (truncate decimals, append %)
  setTimeout(function () {
    var d1 = document.querySelector('.bundle-cart #mobile-cart-main .subscription-radio .discount-label');
    if (d1) d1.textContent = d1.textContent.split('.')[0] + '%';
    var d2 = document.querySelector('.main-product-grid .subscription-radio .discount-label');
    if (d2) d2.textContent = d2.textContent.split('.')[0] + '%';
  }, 1500);

  // Quick-view trigger (desktop + mobile): on click, sync sub-save pricing/quantity into the quick-add modal
  function bindQuickViewTrigger(selector) {
    document.querySelectorAll(selector).forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var gridItem = trigger.closest('.grid-item');
        var varId = gridItem ? gridItem.getAttribute('data-variant-id') : null;
        var dataId = trigger.getAttribute('data-id');
        setTimeout(function () {
          var subsavePrice = document.querySelector('.rc-option__subsave .rc_widget__price--subsave');
          var spriceVal = subsavePrice ? subsavePrice.textContent : '';
          document.querySelectorAll('#case-number-quick option').forEach(function (opt) { opt.setAttribute('data-sprice', spriceVal); });
          if (varId === dataId) {
            var q = document.querySelector('#main-product-quick_add .case-cta .info .quantity');
            if (q) q.textContent = trigger.getAttribute('data-pouches');
            var subText = document.querySelector('.rc-option__subsave .rc-option__text');
            var discount = document.querySelector('.rc_widget__option__discount');
            if (subText) subText.textContent = subText.textContent + ' ' + (discount ? discount.textContent.split('.')[0] : '') + '%';
            if (discount) discount.textContent = '';
          }
        }, 2000);
      });
    });
  }
  bindQuickViewTrigger('.quick-view-trigger');
  bindQuickViewTrigger('.quick-view-trigger-mobile');

  // Case-quantity change -> recompute prices
  document.addEventListener('change', function (e) {
    if (!e.target.matches('#case_quantity')) return;
    var num = e.target.value;
    var vsel = document.querySelector('.product-variants-innerpanel .variant-selector');
    var variantId = vsel ? vsel.value : '';
    if (variantId) {
      document.querySelectorAll('#case-number option').forEach(function (opt) {
        if (opt.getAttribute('data-id') == variantId) {
          var variantPrice = opt.getAttribute('data-price').split('$')[1];
          var subsPrice = opt.getAttribute('data-sprice').split('$')[1];
          var q = document.querySelector('.case-cta .info .quantity'); if (q) q.textContent = opt.value * num;
          var s = document.querySelector('.subscription-radio .price-label'); if (s) s.textContent = '$' + (subsPrice * num).toFixed(2);
          var o = document.querySelector('.onetime-radio .price-label'); if (o) o.textContent = '$' + (variantPrice * num).toFixed(2);
        }
      });
    } else {
      var input = document.querySelector('#main-product-quick_add product-variants input');
      var variantId2 = input ? input.value : '';
      document.querySelectorAll('#case-number-quick option').forEach(function (opt) {
        if (opt.getAttribute('data-id') == variantId2) {
          var variantPrice = opt.getAttribute('data-price').split('$')[1];
          var subsPrice = opt.getAttribute('data-sprice').split('$')[1];
          var q = document.querySelector('#main-product-quick_add .case-cta .info .quantity'); if (q) q.textContent = opt.value * num;
          var s = document.querySelector('#main-product-quick_add .rc-option__subsave .rc_widget__price--subsave'); if (s) s.textContent = '$' + (subsPrice * num).toFixed(2);
          var o = document.querySelector('#main-product-quick_add .rc-option__onetime .rc_widget__price--onetime'); if (o) o.textContent = '$' + (variantPrice * num).toFixed(2);
        }
      });
    }
  });

  // Subscription/one-time radio -> sync quantity display
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.rc-radio')) return;
    var firstQty = document.querySelector('#case_quantity option'); if (firstQty) firstQty.selected = true;
    var qInput = document.querySelector('#main-product-quick_add product-variants input');
    var qVal = qInput ? qInput.value : null;
    document.querySelectorAll('#case-number-quick option').forEach(function (opt) {
      if (opt.getAttribute('data-id') === qVal) {
        var q = document.querySelector('#main-product-quick_add .case-cta .info .quantity'); if (q) q.textContent = opt.value;
      }
    });
    var gSel = document.querySelector('.main-product-grid product-variants .variant-selector');
    var gVal = gSel ? gSel.value : null;
    document.querySelectorAll('#case-number option').forEach(function (opt) {
      if (opt.getAttribute('data-id') === gVal) {
        var q = document.querySelector('.main-product-grid .case-cta .info .quantity'); if (q) q.textContent = opt.value;
        var s = document.querySelector('.main-product-grid .subscription-radio .price-label'); if (s) s.textContent = opt.getAttribute('data-sprice');
        var o = document.querySelector('.main-product-grid .onetime-radio .price-label'); if (o) o.textContent = opt.getAttribute('data-price');
      }
    });
  });
})();
